import styled from "styled-components";
import { grid } from "styled-system";
import BaseComponent from "../Base/BaseComponent";

const Grid = styled(BaseComponent)`
  ${grid}
`;

export default Grid;
